export default __webpack_public_path__ + "static/media/MN.51a09b12.ico";